import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { BackupState } from '../../reducers/backups';

export const getJiraActionsSelector = createSelector((state: DefaultRootState) => state.backups, ({jira}: BackupState) => jira.actions);
export const getJiraActionsTotalSelector = createSelector((state: DefaultRootState) => state.backups, ({jira}: BackupState) => jira.totalActions);
export const isJiraActionsLoadingSelector = createSelector((state: DefaultRootState) => state.backups, ({jira}: BackupState) => jira.loading);
export const getJiraCanRestore = createSelector((state: DefaultRootState) => state.backups, ({jira}: BackupState) => jira.canRestore);
